import { Navigate, Outlet } from 'react-router-dom'
import { useFallbackCookieAuthForRoute } from '~/@api/client/useFallbackCookieAuthForRoute'
import { useStoreFallbackCookieAuthOnMount } from '~/@api/client/useStoreFallbackCookieAuthOnMount'
import { AccountTopNavigation } from '~/@biz_account/top-navigation/AccountTopNavigation'
import { TopBanners } from '~/@biz_notifications/top-banners/TopBanners'
import { UserNotifications } from '~/@biz_notifications/user-notifications/UserNotifications'
import { OnboardingStepper } from '~/@pages_onboarding/_onboarding-stepper/OnboardingStepper'
import { OnboardingGuard } from './OnboardingGuard'

type Props = {
  isAuthenticated: boolean
  withTopNavigation?: boolean
}

export function AuthenticatedRoute({
  isAuthenticated,
  withTopNavigation,
}: Props) {
  const isAuthenticatedWithFallback =
    useFallbackCookieAuthForRoute(isAuthenticated)

  useStoreFallbackCookieAuthOnMount(isAuthenticatedWithFallback)

  if (!isAuthenticatedWithFallback) return <Navigate to="/login" replace />

  return (
    <OnboardingGuard>
      {withTopNavigation && (
        <>
          <AccountTopNavigation />
          <OnboardingStepper />
          <TopBanners />
          <UserNotifications />
        </>
      )}
      <Outlet />
    </OnboardingGuard>
  )
}
